import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  form: {
    color: '#1e1e1e',
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formControl: {
    margin: 0,
  },
  inputLabel: {
    marginLeft: 10,
  },
}));
